import { Layout } from '@/utils/routerHelper'

// 前端运营
export default {
  path: '/front-operation',
  redirect: '/information-admin',
  component: Layout,
  name: 'FrontOperation',
  meta: {
    title: '前端运营',
    icon: 'vi-ant-design:dashboard-filled',
    alwaysShow: true
  },
  children: [
    {
      path: 'information-admin',
      name: 'InformationAdmin',
      component: () => import('@/views/FrontOperation/InformationAdmin/InformationList/Index.vue'),
      meta: {
        title: '资讯管理'
      },
      children: [
        {
          path: 'edit',
          name: 'InformationEdit',
          component: () =>
            import('@/views/FrontOperation/InformationAdmin/InformationEdit/Index.vue'),
          meta: {
            title: '新增文章',
            hidden: true,
            canTo: true,
            activeMenu: '/front-operation/information-admin'
          }
        }
      ]
    },
    {
      path: 'information-type',
      name: 'InformationType',
      component: () => import('@/views/FrontOperation/InformationType/Index.vue'),
      meta: {
        title: '资讯类型'
      }
    },
    {
      path: 'app-advertising',
      name: 'AppAdvertising',
      component: () => import('@/views/FrontOperation/AppAdvertising/Index.vue'),
      meta: {
        title: 'APP启动广告'
      }
    },
    {
      path: 'template-list',
      name: 'FrontTemplateList',
      component: () => import('@/views/FrontOperation/Template/TemplateList/Index.vue'),
      meta: {
        title: '商城装修'
      },
      children: [
        {
          path: 'detail',
          name: 'FrontTemplateDetail',
          component: () => import('@/views/FrontOperation/Template/TemplateDetail/Index.vue'),
          meta: {
            title: '装修详情',
            hidden: true,
            canTo: true,
            activeMenu: '/front-operation/template-list'
          }
        }
      ]
    }
  ]
} as AppRouteRecordRaw
